webpackJsonp(["presubmit-check"],{

/***/ "/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/client/src/core/modules/presubmit-check/presubmit-check.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vanillaPlugin = __webpack_require__("/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/client/src/core/lib/vanilla-plugin.js");

var _vanillaPlugin2 = _interopRequireDefault(_vanillaPlugin);

var _windcavePresubmit = __webpack_require__("/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/client/src/core/modules/windcave-presubmit/windcave-presubmit.js");

var _windcavePresubmit2 = _interopRequireDefault(_windcavePresubmit);

var _recaptchaPresubmit = __webpack_require__("/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/client/src/core/modules/recaptcha-presubmit/recaptcha-presubmit.js");

var _recaptchaPresubmit2 = _interopRequireDefault(_recaptchaPresubmit);

var _debug = __webpack_require__("/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('presubmit-check');

var PresubmitCheck = function () {
	function PresubmitCheck(element) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, PresubmitCheck);

		this.element = element;
		this.options = options;
		this.init();
	}

	_createClass(PresubmitCheck, [{
		key: 'init',
		value: function init() {
			log(this.element, this.options);

			if (this.element.dataset.recaptchaPresubmit !== undefined) {
				this.recaptchaPresubmit = (0, _vanillaPlugin2.default)('recaptchaPresubmit', _recaptchaPresubmit2.default, [this.element])({ isWatching: false });
			}

			if (this.element.dataset.windcavePresubmit !== undefined) {
				this.windcavePresubmit = (0, _vanillaPlugin2.default)('windcavePresubmit', _windcavePresubmit2.default, [this.element])({ isWatching: false });
			}

			this.element.addEventListener('submit', this.onSubmit.bind(this));
		}
	}, {
		key: 'onSubmit',
		value: function onSubmit(event) {
			var _this = this;

			event.preventDefault();

			var validations = [];

			if (this.recaptchaPresubmit) {
				validations.push(this.recaptchaPresubmit[0].requestValidation());
			}

			if (this.windcavePresubmit) {
				validations.push(this.windcavePresubmit[0].requestValidation());
			}

			Promise.all(validations).then(function () {
				_this.element.submit();
				log('Form submitted');
			}).catch(function (error) {
				log('Error', error);

				_this.element.dispatchEvent(new CustomEvent('enableSubmit', {
					bubbles: false,
					cancelable: true
				}));
			});
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this.element.form.removeEventListener('submit', this.onSubmit);
		}
	}]);

	return PresubmitCheck;
}();

PresubmitCheck.DEFAULTS = {};

exports.default = PresubmitCheck;

/***/ }),

/***/ "/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/client/src/core/modules/recaptcha-presubmit/recaptcha-presubmit.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('recaptcha-presubmit');

var RecaptchaPresubmit = function () {
	function RecaptchaPresubmit(element, options) {
		_classCallCheck(this, RecaptchaPresubmit);

		log('element', element);
		log('options', options);

		this.options = options;
		this.form = element;

		this.recaptchaSiteKey = this.options.recaptchaSiteKey;
		this.recaptchaValidationUrl = this.options.recaptchaValidationUrl;
		this.responseInput = this.form.querySelector(this.options.responseInputSelector);
		this.responseErrorElement = this.form.querySelector(this.options.responseErrorSelector);
		this.prefix = this.options.sitePrefix;

		this.init(options.isWatching);
	}

	_createClass(RecaptchaPresubmit, [{
		key: 'init',
		value: function init(isWatching) {
			this.addRecaptchaScript();

			if (isWatching) {
				this.watch();
			}
		}
	}, {
		key: 'watch',
		value: function watch() {
			this.form.addEventListener('submit', this.onFormSubmit.bind(this));
		}

		// Only called if isWatching is not false

	}, {
		key: 'onFormSubmit',
		value: function onFormSubmit(event) {
			log('onFormSubmit', event);
			event.preventDefault();
			this.responseErrorElement.hidden = true;
			window.grecaptcha.ready(this.onRecaptchaReady.bind(this));
		}
	}, {
		key: 'onRecaptchaReady',
		value: function onRecaptchaReady() {
			try {
				return window.grecaptcha.execute(this.recaptchaSiteKey, { action: 'submit' }).then(this.onRecaptchaResponse.bind(this));
			} catch (error) {
				this.displayValidationError(error.message);
				return Promise.reject(error);
			}
		}
	}, {
		key: 'addRecaptchaScript',
		value: function addRecaptchaScript() {
			if (!window.grecaptcha) {
				var recaptchaScriptEl = document.createElement('script');
				recaptchaScriptEl.src = 'https://www.google.com/recaptcha/api.js?render=' + this.recaptchaSiteKey;
				recaptchaScriptEl.onload = this.onRecaptchaScriptLoaded.bind(this);
				document.body.appendChild(recaptchaScriptEl);
			} else {
				this.onRecaptchaScriptLoaded();
			}
		}
	}, {
		key: 'onRecaptchaScriptLoaded',
		value: function onRecaptchaScriptLoaded() {
			log('onRecaptchaScriptLoaded');
		}
	}, {
		key: 'requestValidation',
		value: function requestValidation() {
			var _this = this;

			return new Promise(function (resolve, reject) {
				_this.responseErrorElement.hidden = true;
				window.grecaptcha.ready(function () {
					window.grecaptcha.execute(_this.recaptchaSiteKey, { action: 'submit' }).then(function (token) {
						resolve(_this.onRecaptchaResponse(token));
					}).catch(function (error) {
						_this.displayValidationError(error.message);
						reject(error);
					});
				});
			});
		}
	}, {
		key: 'onRecaptchaResponse',
		value: function onRecaptchaResponse(token) {
			var url = new URL(this.recaptchaValidationUrl, window.location.origin);
			url.searchParams.set('token', token);
			url.searchParams.set('prefix', this.prefix);
			log('onRecaptchaResponse', token);

			return fetch(url).then(function (response) {
				if (response.ok) {
					return response.json();
				}
				return Promise.reject(response);
			}).then(this.onRecaptchaRequestSuccess.bind(this)).catch(this.onRecaptchaRequestError.bind(this));
		}
	}, {
		key: 'onRecaptchaRequestSuccess',
		value: function onRecaptchaRequestSuccess(data) {
			log('onRecaptchaValidationSuccess', data);

			if (data.Success === true) {
				// add data.Result to SessionId field in the form and submit form
				this.responseInput.value = data.Result;
			} else {
				// data.Result contains the error message
				this.displayValidationError(data.Result);
			}
		}
	}, {
		key: 'onRecaptchaRequestError',
		value: function onRecaptchaRequestError() {
			log('onRecaptchaValidationError');
			// This happens is the API call fails
			this.displayValidationError('Something went wrong. Please reload the page and try again.');
		}
	}, {
		key: 'displayValidationError',
		value: function displayValidationError(errorMessage) {
			log('displayValidationError', errorMessage);
			this.responseErrorElement.hidden = false;

			if (this.options.onErrorEvent) {
				this.form.dispatchEvent(new CustomEvent(this.options.onErrorEvent, {
					bubbles: false,
					cancelable: true
				}));
			}
		}
	}]);

	return RecaptchaPresubmit;
}();

RecaptchaPresubmit.DEFAULTS = {
	responseInputSelector: '[data-presubmit-response]',
	responseErrorSelector: '[data-presubmit-error]',
	recaptchaValidationUrl: '/api/recaptcha',
	onErrorEvent: false
};

exports.default = RecaptchaPresubmit;

/***/ }),

/***/ "/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/client/src/core/modules/windcave-presubmit/windcave-presubmit.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/opt/atlassian/pipelines/agent/build/node_modules/babel-loader/lib/index.js??ref--23-0!/opt/atlassian/pipelines/agent/build/node_modules/eslint-loader/index.js!/opt/atlassian/pipelines/agent/build/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('windcave-presubmit');

var WindcavePresubmit = function () {
	function WindcavePresubmit(element, options) {
		_classCallCheck(this, WindcavePresubmit);

		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;

		this.validationUrl = this.options.validationUrl;

		this.responseErrorElement = this.element.querySelector(this.options.responseErrorSelector);
		this.prefix = this.options.sitePrefix;
		this.sessionId = this.options.sessionId;

		this.init(options.isWatching);
	}

	_createClass(WindcavePresubmit, [{
		key: 'init',
		value: function init(isWatching) {
			if (!this.validationUrl) {
				log('No validation URL provided: data-windcave-presubmit-validation-url="". Aborting...');
				return false;
			}

			if (!this.responseErrorElement) {
				log('No response error element found matching: "' + this.options.responseErrorSelector + '". Aborting...');
				return false;
			}

			if (!this.sessionId) {
				log('No session ID provided: data-windcave-presubmit-session-id="". Aborting...');
				return false;
			}

			if (isWatching) {
				this.watch();
			}
		}
	}, {
		key: 'watch',
		value: function watch() {
			this.element.addEventListener('submit', this.onFormSubmit.bind(this));
		}

		// Only called if isWatching is not false

	}, {
		key: 'onFormSubmit',
		value: function onFormSubmit(event) {
			log('onFormSubmit', event);
			event.preventDefault();
			this.responseErrorElement.hidden = true;
			this.requestValidation();
		}
	}, {
		key: 'requestValidation',
		value: function requestValidation() {
			var url = new URL(this.validationUrl, window.location.origin);
			url.searchParams.set('windcavesessionid', this.sessionId);
			url.searchParams.set('prefix', this.prefix);

			return fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(function (response) {
				if (response.ok) {
					return response.json();
				}
				return Promise.reject(response);
			}).then(this.onRequestSuccess.bind(this)).catch(this.onRequestError.bind(this));
		}
	}, {
		key: 'onRequestSuccess',
		value: function onRequestSuccess(data) {
			log('onValidationSuccess', data);

			// data may contain an error message
			if (data !== true) {
				this.displayRequestError(data);
			}
		}
	}, {
		key: 'onRequestError',
		value: function onRequestError(error) {
			log('onValidationError');

			// This happens if the API call fails
			this.displayRequestError(error);
		}
	}, {
		key: 'displayRequestError',
		value: function displayRequestError(errorMessage) {
			log('displayValidationError', errorMessage);

			this.responseErrorElement.hidden = false;

			if (this.options.onErrorEvent) {
				this.element.dispatchEvent(new CustomEvent(this.options.onErrorEvent, {
					bubbles: false,
					cancelable: true
				}));
			}

			throw new Error(errorMessage);
		}
	}]);

	return WindcavePresubmit;
}();

WindcavePresubmit.DEFAULTS = {
	responseErrorSelector: '[data-windcave-error]',
	onErrorEvent: false
};

exports.default = WindcavePresubmit;

/***/ })

});


// WEBPACK FOOTER //
// scripts/presubmit-check--2e4ea3e68a79ce422368.js